/**
 * Payment method values
 */
export enum PaymentMethodEnum {
	CASH = 'cash',
	CARD = 'card',
	TRANSFER = 'transfer',
	CHECK = 'check',
	OTHER = 'other',
}
